var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVerifiedGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3176 1.07835C27.9417 0.934903 28.5951 0.989347 29.1868 1.23412C29.7786 1.4789 30.2795 1.90186 30.6199 2.44428L33.6848 7.33758C33.9319 7.7317 34.265 8.0648 34.6591 8.31192L39.5524 11.3768C40.096 11.717 40.52 12.2182 40.7653 12.8106C41.0107 13.403 41.0653 14.0572 40.9214 14.6821L39.6264 20.3062C39.5219 20.7607 39.5219 21.233 39.6264 21.6876L40.9214 27.3147C41.0639 27.9387 41.0086 28.5915 40.7633 29.1827C40.518 29.7739 40.0948 30.2741 39.5524 30.6139L34.6591 33.6818C34.265 33.929 33.9319 34.2621 33.6848 34.6562L30.6199 39.5495C30.2799 40.0925 29.7792 40.516 29.1874 40.7614C28.5956 41.0067 27.9421 41.0616 27.3176 40.9185L21.6905 39.6235C21.2369 39.5195 20.7658 39.5195 20.3122 39.6235L14.6851 40.9185C14.0606 41.0616 13.4071 41.0067 12.8153 40.7614C12.2235 40.516 11.7228 40.0925 11.3828 39.5495L8.31793 34.6562C8.06993 34.2617 7.73575 33.9286 7.34051 33.6818L2.45029 30.617C1.90731 30.277 1.48372 29.7763 1.23838 29.1845C0.993036 28.5927 0.938125 27.9391 1.08128 27.3147L2.37321 21.6876C2.47768 21.233 2.47768 20.7607 2.37321 20.3062L1.07819 14.6821C0.934643 14.0569 0.989672 13.4025 1.23561 12.81C1.48156 12.2176 1.90617 11.7165 2.45029 11.3768L7.34051 8.31192C7.73575 8.06516 8.06993 7.73204 8.31793 7.33758L11.3828 2.44428C11.723 1.90245 12.2234 1.47987 12.8145 1.23513C13.4057 0.990387 14.0583 0.935595 14.682 1.07835L20.3122 2.37028C20.7658 2.47428 21.2369 2.47428 21.6905 2.37028L27.3176 1.07835Z",
    stroke: "#FABB18",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3377 22.6488L19.6123 28.6583L28.662 13.334",
    stroke: "#FABB18",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVerifiedGold);
export default __webpack_public_path__ + "static/media/icon-verified-gold.040cfdf71ff552c2807a80fca888cefb.svg";
export { ForwardRef as ReactComponent };